export const SUPPORTED_LANGUAGES = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'en-GB',
    label: 'English (United Kingdom)',
  },
  {
    value: 'pt-pt',
    label: 'Português - Portugal',
  },
  {
    value: 'id',
    label: 'Bahasa Indonesia',
  },
  {
    value: 'es',
    label: 'Español',
  },
  {
    value: 'tr',
    label: 'Türkçe',
  },
  {
    value: 'es-MX',
    label: 'Español - Mexico',
  },
  {
    value: 'ms',
    label: 'Bahasa Melayu',
  },
] as const
